import { Descendant } from '../../editor/types'
import { UserGroup } from '../shared/db'
import { AutoDisplayCondition, ConsentFormTemplate, TemplateExternalPdf } from '../templates'
import { FieldMapValue, WithId } from '../utils/common'
import { AssessmentDocument, AssessmentDocumentVersion } from './documents'

export interface ConsentFormVersion extends AssessmentDocumentVersion {
  formData: FieldMapValue | null
  toBeSignedByUser: string
  signedOn: number | null
  signedBy: string | null
  signedStoragePath: string | null
}

export interface ConsentFormMovedFromThread {
  type: 'thread'
  threadId: string
  messageGroupId: string
  messageId: string
  by: string
  byUserGroup: UserGroup
}

export interface ConsentFormMovedFromFiles {
  type: 'files'
  assessmentId: string | null
  fileId: string
  by: string
  byUserGroup: UserGroup
}

// specific to patient
export interface ConsentForm
  extends Omit<
    AssessmentDocument,
    | 'previousVersions'
    | 'expiresOn'
    | 'expired'
    | 'assessmentArchived'
    | 'assessmentId'
    | 'text'
    | 'name'
  > {
  type: 'consentForm'
  name: string
  formData: FieldMapValue | null
  previousVersions?: ConsentFormVersion[]
  signedOn: number | null
  signedBy: string | null
  consentFormTemplateId: string
  practiceId: string | null
  signedStoragePath: string | null
  signedOffSite?: boolean
  movedFrom?: ConsentFormMovedFromThread | ConsentFormMovedFromFiles
  isExternalPdf?: boolean
  externalPdf: TemplateExternalPdf | null
  toBeSignedByUser: string
  text: Descendant[] | null
}

export const isConsentForm = (doc: { type?: string } | null | undefined): doc is ConsentForm =>
  !!doc && doc.type === 'consentForm'

export interface ConsentFormStatusVersion {
  name: string
  consentFormId: string
  sentOn: number
  signedOn: number | null
  signedBy: string | null
  signedStoragePath: string | null
  formData: FieldMapValue | null
}

export interface PatientConsentFormStatus extends ConsentFormStatusVersion {
  templateId: string
  practiceId: string | null
  previousVersions: ConsentFormStatusVersion[]
  status: 'sent' | 'signed' | 'resent'
}

export type ConsentFormTemplateId = string
export type PatientConsentFormsStatus = Record<ConsentFormTemplateId, PatientConsentFormStatus>

export interface DefaultConsentForms {
  practiceId: string | null
  hb: Array<{
    form: WithId<ConsentFormTemplate>
    conditions: AutoDisplayCondition[]
  }>
  practice: Array<{
    form: WithId<ConsentFormTemplate>
    conditions: AutoDisplayCondition[]
  }>
}
